var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.curInfo)?_c('audio',{ref:"bgm",staticStyle:{"height":"0"},attrs:{"id":"bgm","preload":"auto","loop":_vm.isRandom=='circle',"src":_vm.curInfo.src},on:{"canplay":_vm.audioCanPlay,"durationchange":_vm.audioChange,"timeupdate":_vm.updateTime,"ended":_vm.audioEnd,"loadedmetadata":_vm.loadALl}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }